import { Permission } from '@/common/enums/permissions.enum';
import type { TechSystemMemberLevel } from '@/features/tech-systems/services/tech-systems.service';

export function canAccessTechSystemsModule(
  hasPermission: (permission: string) => boolean,
): boolean {
  return (
    hasPermission(Permission.TECH_SYSTEMS_VIEW) ||
    hasPermission(Permission.TECH_SYSTEMS_MANAGE) ||
    hasPermission(Permission.TECH_SYSTEMS_CONFIG)
  );
}

export function canAccessProjectsHub(
  hasPermission: (permission: string) => boolean,
): boolean {
  return (
    hasPermission(Permission.TECH_SYSTEMS_PROJECTS_VIEW) ||
    hasPermission(Permission.TECH_SYSTEMS_MANAGE) ||
    hasPermission(Permission.TECH_SYSTEMS_CONFIG)
  );
}

export function resolveProjectsHubCanEdit({
  hasPermission,
  memberLevel,
}: {
  hasPermission: (permission: string) => boolean;
  memberLevel?: TechSystemMemberLevel | null;
}): boolean {
  const canManageGlobal = hasPermission(Permission.TECH_SYSTEMS_MANAGE);
  const canConfig = hasPermission(Permission.TECH_SYSTEMS_CONFIG);

  return (
    canAccessProjectsHub(hasPermission) &&
    (canManageGlobal || canConfig || memberLevel === 'manager')
  );
}
